import React from "react";

import { Logo } from "components/atoms/logo/index";
import * as S from "./signup.heder.styles";

export const SignupHeader = (props) => {
  return (
    <S.Header>
      <S.LogoSection>
        <S.LogoSectionImage>
          <Logo company={props.company} />
        </S.LogoSectionImage>
      </S.LogoSection>
    </S.Header>
  );
};
